//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

const getDataValue = (dataObject: Record<string, object | string> | undefined, propName: string): any => {
  if (!dataObject) {
    return undefined
  }
  if (!propName.includes('.')) {
    return dataObject[propName]
  }
  const firstProp = propName.split('.')[0]
  const subObject = dataObject[firstProp] as Record<string, object | string>
  const subProp = propName.substring(propName.indexOf('.') + 1)
  return getDataValue(subObject, subProp)
}

export default getDataValue
